import React, { useState, useRef, useEffect } from 'react'
import { ContextLoader } from '../context'
import Loader from './Loader'
import Transition from './Transition'
import Nav from './Nav'
import Footer from './Footer'
import CookiesNotice from './CookiesNotice'
import Seo from './Seo'
import DetectColor from '../helpers/detectColor'
import capitalizeFirstLetter from '../helpers/capitalizeFirstLetter'
import '../styles/style.scss'
import '../helpers/noSSR'
import '../helpers/requestInterval'
import { initGtm, handlePageView } from '../services/GoogleTagManager'
import detectBrowser from '../utils/detectBrowser';
import detectOs from '../utils/detectOs';

const Layout = ({ children, location, data }) => {
	const [isLoading, updateIsLoading] = useState(true)

	detectBrowser()
	detectOs()

	const detectColor = useRef(new DetectColor())
	const detectColorTimeoutId = useRef(null)
	useEffect(() => {
		detectColorTimeoutId.current = setTimeout(() => {
			clearTimeout(detectColorTimeoutId.current)
			detectColor.current.destroy()
			detectColor.current.init()
		}, 2000)
	}, [location.pathname])

	/*
	*	Google Tag Manager
	*/
	useEffect(() => {
		if (localStorage.getItem('areCookiesAgreed') === 'true') {
			initGtm()
		}
	}, [])

	useEffect(() => {
		handlePageView(location)
	}, [location])


	const pageName = getPageNameFromPathname(location.pathname)
	const seoFormattedPageName = getSeoFormattedPageName(location.pathname)

	const metaDescription = data.prismicSeo ? data.prismicSeo.data.meta_description.text : ''

	return (
		<div className={`AppProof ${pageName}`}>
			<ContextLoader.Provider value={[isLoading, updateIsLoading]}>
				<Seo
					title={seoFormattedPageName}
					description={metaDescription}
				/>
				<Loader/>
				<Nav hamburgerData={data.prismicFooter.data} data={data.prismicNav.data}/>
				<Transition location={location} pageName={pageName}>
					<div className="AppProof__Wrapper">
						{children}
					</div>
				</Transition>
				<CookiesNotice data={data.prismicCookiesNotice.data} location={location}/>
				<Footer data={data.prismicFooter.data} location={location}/>
			</ContextLoader.Provider>
		</div>
	)
}

const getPageNameFromPathname = pathname => {
	if (pathname === '/') {
		return 'homepage'
	}
	else if (pathname.search('/article') !== -1) {
		return 'article'
	}
	else if (pathname.search('/solution/') !== -1) {
		return 'solution'
	}
	else if (pathname.search('/product/') !== -1) {
		return 'product'
	}
	else if (pathname.search('/legal/') !== -1) {
		return 'legal'
	}
	else {
		return pathname.replaceAll('/', '')
	}
}

const getSeoFormattedPageName = pathname => {
	if (pathname === '/') {
		return ''
	}
	else {
		const pageName = getPageNameFromPathname(pathname)
		return capitalizeFirstLetter(pageName)
	}
}

export default Layout